<script setup lang="ts">
    import type { CustomField } from "common";

    const { fields = [] } = defineProps<{ fields?: CustomField[] }>();
</script>

<template>
    <template v-for="field in fields as CustomField[]" :key="field.id">
        <template v-if="field.type === 'string'">
            <checkout-custom-fields-string-field :field="field" />
        </template>
        <template v-else-if="field.type === 'integer'">
            <checkout-custom-fields-integer-field :field="field" />
        </template>
        <template v-else-if="field.type === 'boolean'">
            <checkout-custom-fields-boolean-field :field="field" />
        </template>
    </template>
</template>
